module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (1).f66e9dca.jpg";